import React from "react";

export default function RowAuvik({ item }) {
    return (
        <div className="auvik-alerts-row">
            <h1>Description :</h1>
            <p>{item.Description}</p>
        </div>
    );
}